module.exports = __webpack_public_path__ + "assets/appStore-770fac.svg";